import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { LoginRoutingModule } from './login-routing.module';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { NgOtpInputModule } from 'ng-otp-input';
import { VerificationComponent } from './verification/verification.component';

@NgModule({
  declarations: [LoginComponent, VerificationComponent],
  imports: [
    CommonModule,
    LoginRoutingModule,
    ToastrModule,
    ReactiveFormsModule,
    NgOtpInputModule,
  ],
})
export class LoginModule {}
